<div *ngIf="antennesCompletes.length > 0">
	<ng-template [ngIf]="antennesCompletes.length === 1">
		Antenne compl&egrave;te&nbsp;:
	</ng-template>
	<ng-template [ngIf]="antennesCompletes.length > 1">
		Antennes compl&egrave;tes&nbsp;:
	</ng-template>
	<strong>
		<ng-template ngFor let-antenne let-index="index" [ngForOf]="antennesCompletes">{{ index === 0 ? '' : ', ' }}{{ antenne }}</ng-template>
	</strong>
</div>
<ng-template ngFor let-antenne [ngForOf]="antennesIncompletes">
	<div>Antenne <strong>{{ antenne.nom }}&nbsp;:</strong></div>
	<div class="indented">
		<div *ngIf="antenne.parcsComplets.length > 0">
			<ng-template [ngIf]="antenne.parcsComplets.length === 1">
				Parc complet&nbsp;:
			</ng-template>
			<ng-template [ngIf]="antenne.parcsComplets.length > 1">
				Parcs complets&nbsp;:
			</ng-template>
			<strong>
				<ng-template ngFor let-parc let-index="index" [ngForOf]="antenne.parcsComplets">{{ index === 0 ? '' : ', ' }}{{ parc }}</ng-template>
			</strong>
		</div>
		<ng-template ngFor let-parc [ngForOf]="antenne.parcsIncomplets">
			<div>
				Parc <strong>{{ parc.code }}</strong>&nbsp;:
				<ng-template ngFor let-ouvrage let-index="index" [ngForOf]="parc.ouvrages">{{ index === 0 ? '' : ', ' }}{{ ouvrage }}</ng-template>
			</div>
			<div class="indented">
				<div *ngIf="parc.sousParcsComplets.length > 0">
					<ng-template [ngIf]="parc.sousParcsComplets.length === 1">
						Sous-parc complet&nbsp;:
					</ng-template>
					<ng-template [ngIf]="parc.sousParcsComplets.length > 1">
						Sous-parcs complets&nbsp;:
					</ng-template>
					<strong>
						<ng-template ngFor let-sousparc let-index="index" [ngForOf]="parc.sousParcsComplets">{{ index === 0 ? '' : ', ' }}{{ sousparc }}</ng-template>
					</strong>
				</div>
				<div *ngFor="let sousparc of parc.sousParcsIncomplets">
					Sous-parc <strong>{{ sousparc.code }}</strong>&nbsp;:
					<ng-template ngFor let-ouvrage let-index="index" [ngForOf]="sousparc.ouvrages">{{ index === 0 ? '' : ', ' }}{{ ouvrage }}</ng-template>
				</div>
			</div>
		</ng-template>
	</div>
</ng-template>	
<div *ngIf="antennesCompletes.length === 0 && antennesIncompletes.length === 0">
	Aucun perim&egrave;tre assign&eacute;.
</div>